import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import Waves from "../../components/atoms/Waves";

// Import Swiper styles
import "swiper/css";
import { Autoplay } from "swiper/modules";
import Ariane from "../../components/molecules/Ariane";

export const HeroInner = ({ imagesSwiper, arianeItem }) => {
    return (
        <>
            <div className="containerHeroInner position-relative">
                <Swiper
                    loop={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay]}
                    style={{
                        position: "absolute",
                        zIndex: "-1",
                        minHeight: "606px",
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                    }}
                >
                    {imagesSwiper && (
                        <>
                            {imagesSwiper.map((image, index) => (
                                <SwiperSlide key={index}>
                                    <img
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                        src={image}
                                        alt={`Slide ${index + 1}`}
                                        title={`Slide ${index + 1}`}
                                        loading="lazy"
                                    />
                                </SwiperSlide>
                            ))}
                        </>
                    )}
                </Swiper>
                <div className="vitaleu-container-hero-inner ripple-effect">
                    <div className="vitaleau-container-back">
                        <Container maxWidth="xl">
                            <Grid container>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Ariane arianeItem={arianeItem} />
                                </Grid>
                            </Grid>
                        </Container>
                    </div>
                </div>
                <Waves />
            </div>
        </>
    );
};

HeroInner.propTypes = {
    /**
     * Optional click handler
     */
    onClick: PropTypes.func,
    swiperActivityProps: PropTypes.bool,
};
